import React, { useState } from "react";
import { Button, FormControl, TextField, Box, Typography, Paper, Stack } from '@mui/material';
import LoadingScreen from '../../../components/LoadingScreen'
import { useParams, useNavigate } from "react-router-dom";
import ApiConfig from '../../../utils/services/apiConfig'
import { useKeycloak } from '@react-keycloak/web';
import { useMountEffect } from '../../../utils/hooks';

// const LoadingScreen = ({ open }) => (
//     <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={open}>
//         <CircularProgress color="inherit" />
//     </Backdrop>
// );

function EditType(props) {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [, setRobots] = useState([])
  const [type, setType] = useState({});
  const { keycloak } = useKeycloak();
  const a = new ApiConfig(keycloak)
  const apiConfig = a.api()
  const navigate = useNavigate();

  const initRetrieve = () => {
    Promise.all([
        apiConfig.fetchRobotData(0),
        apiConfig.fetchRobotType(id)
    ]).then(results => {
        console.log(results[0])
        setRobots(results[0].RobotResponse)
        console.log(results[1])
        setType(results[1].RobotResponse)
    }).catch(error => {
        console.error(error);
    });
  }

  useMountEffect(() => {
    initRetrieve()
  }, []);

  const handleSave = () => {
    // console.log(type)
    setLoading(true);
    Promise.all([
        apiConfig.updateRobotType(type.Id, type),
    ]).then(results => {
        // setTimeout(() => {
        console.log(results[0])
        setLoading(false);
        navigate("/managements/type_management");
        // }, 5000);
    }).catch(error => {
        console.error(error);
    });
  }

  const handleTypeChanges = (e) => {
    const { name, value } = e.target;
    setType(prevState => ({ ...prevState, [name]: value }));
    setType(prevState => ({ ...prevState, "UpdatedBy": keycloak.tokenParsed?.preferred_username || "system" }));
  };

  const handleCancel = () => {
    setLoading(false)
    setRobots([])
    setType({})
    navigate("/managements/type_management");
  }

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onloadend = () => {
      setType((prev) => ({
        ...prev,
        Image: reader.result.split(',')[1] // remove MIME type
      }));
    };
    reader.readAsDataURL(file);
  };

  return (
    <Box p={2}>
    <LoadingScreen open={loading} />
      <Typography variant="h4">Edit Robot Type {type.Name}</Typography>
      <Paper elevation={3} sx={{ p: 2, mt: 2 }}>
        <form onSubmit={(e) => { e.preventDefault(); handleSave(); }}>
          <FormControl fullWidth sx={{ mb: 2 }}>
            <TextField
                fullWidth
                label="Robot Type"
                name="Type"
                variant="outlined"
                value={type.Type}
                InputLabelProps={{ shrink: true }}
                onChange={handleTypeChanges}
                sx={{ mb: 2 }}
            />
            <TextField
                fullWidth
                label="Name"
                name="Name"
                variant="outlined"
                value={type.Name}
                InputLabelProps={{ shrink: true }}
                onChange={handleTypeChanges}
                sx={{ mb: 2 }}
            />
          </FormControl>

          {/* Image Upload Section */}
          <Stack direction="row" spacing={2} alignItems="center" sx={{ mb: 2 }}>
            <Button variant="contained" component="label">
              Upload Image
              <input hidden type="file" accept="image/*" onChange={handleImageUpload} />
            </Button>

            {type.Image && (
              <img
                src={`data:image/jpeg;base64,${type.Image}`}
                alt="robot"
                style={{
                  maxHeight: '120px',
                  minHeight: '80px',
                  maxWidth: '100%',
                  height: 'auto',
                  width: 'auto',
                  objectFit: 'contain',
                }}
              />
            )}
          </Stack>

          <Button variant="contained" color="primary" type="submit">
            Save
          </Button>
          <Button variant="contained" color="primary" type="button" onClick={handleCancel}>
            Cancel
          </Button>
        </form>
      </Paper>
    </Box>
  );
}

export default EditType;
